<template>
  <div class="contracts_orders">
    <!-- Contracts -->
    <div class="row">
      <div class="col-12">
        <b-card header="Contracts" header-tag="h4" body-class="mb-3 record_card_body">
          <div v-if="crmType === 'payroll' && check_for_pdf_fields_problem.length > 0" class="col-12 text-center">
            <h4 class="font-weight-bold red_color mt-3">YOU MUST FILL IN THE BLANK FIELDS BEFORE YOU CREATE NEW CONTRACT</h4>
            <div class="col-12 text-left">
              <ul>
                <li v-for="(problem, index) in check_for_pdf_fields_problem" :key="index">
                  {{ problem.message }}
                  <button
                    v-if="problem.category === 'dashboard_notes'"
                    @click="show_record_company(problem.category)"
                    class="btn btn-success mb-2 mr-1 ml-1"
                    title="View Record"
                  >
                    DASHBOARD & NOTES
                  </button>
                  <button
                    v-if="problem.category === 'accounts_payment'"
                    @click="show_record_company(problem.category)"
                    class="btn btn-primary mb-2 mr-1 ml-1"
                    title="View Record"
                  >
                    ACCOUNTS & PAYMENT
                  </button>
                </li>
              </ul>



            </div>
          </div>
          <!-- No contract(s) -->
          <div v-if="!are_there_contracts" class="row">
            <div class="col-12">
              <h4 class="mb-0 bp_color">Send <span v-if="crmType === 'payroll'">Genius
              Money</span><span v-else-if="crmType === 'recruitment'">V3 Recruitment</span> contract to company</h4>
              <p class="pt-0">Email client a link to e-sign contract</p>
            </div>
            <!-- No Registered Address for the company -->
            <div v-if="!check_for_registered_address" class="col-12 text-center">
              <h4 class="font-weight-bold red_color mt-3">YOU MUST ADD A REGISTERED OFFICE ADDRESS FOR THIS COMPANY BEFORE YOU CAN SEND A CONTRACT</h4>
            </div>
          </div>
          <!-- Contracts exist -->
          <div v-if="are_there_contracts" class="row">
            <div v-if="!show_contract_form && check_for_pdf_fields_problem.length === 0" class="col-12 text-right">
              <button @click="show_create_contract" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Create new contract</button>
            </div>
            <div id="not_full_height_ccd" class="col-12" v-if="!show_contract_form">
              <company_contracts_datatable :row-data="contracts" :loading-message="'Loading Contracts...'" :no-rows-message="'No Contracts To Load'"
                                           :columns="contracts_columns" :type="'contracts'" :record-type="'company'"></company_contracts_datatable>
            </div>
          </div>
          <!-- Form to create and send contract to company contact -->
          <div v-if="((!are_there_contracts && check_for_registered_address) || show_contract_form) && check_for_pdf_fields_problem.length === 0" class="row">
            <div class="col-12">
              <ValidationObserver ref="sendContractForm" slim>
                <form role="form" @submit.prevent="send_contract_submit">
                  <div class="row">
                    <!-- Company Name -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Company Name" tag="div" class="col-lg-5 form-group">
                      <label class="form-label" for="company_name">Company Name</label>
                      <input type="text" v-model="send_contract.company_name" id="company_name" name="company_name" class="form-input disabled" :class="classes" readonly>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- LTD Registration Number -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="LTD Reg Number" tag="div" class="col-lg-3 form-group">
                      <label class="form-label" for="ltd_reg_number">LTD Registration Number</label>
                      <input type="text" v-model="send_contract.ltd_reg_number" id="ltd_reg_number" name="ltd_reg_number" class="form-input disabled" :class="classes" readonly>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- CRM Company -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="CRM Company" tag="div" class="col-xl-4 form-group"
                                        v-if="crmType === 'recruitment'">
                      <label class="form-label" for="crm_company">CRM Company</label>
                      <multiselect v-model="send_contract.crm_company" id="crm_company" class="requiredField" :class="classes" name="crm_company" placeholder=""
                                   :options="ms_opts.crm_company" select-label=""></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="CRM Company" tag="div" class="col-xl-4 form-group"
                                        v-if="crmType === 'payroll'">
                      <label class="form-label" for="crm_company">CRM Company</label>
                      <input type="text" v-model="send_contract.crm_company" id="crm_company" name="crm_company" class="form-input disabled" :class="classes" readonly>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Registered Address -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Registered Address" tag="div" class="col-12 form-group">
                      <label class="form-label" for="registered_address">Registered Address</label>
                      <input type="text" v-model="send_contract.registered_address" id="registered_address" name="registered_address" class="form-input disabled"
                             :class="classes" readonly>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <div class="col-12">
                      <hr class="mt-3 mb-3">
                    </div>
                  </div>
                  <div class="row">
                    <!-- Select Contact to send Contract to -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Select Contact to send Contract to" tag="div"
                                        class="col-xl-6 form-group" id="send_to_contact_container">
                      <label class="form-label" for="send_to_contact">Select Contact to send Contract to</label>
                      <multiselect v-model="send_to_contact" placeholder="" id="send_to_contact" label="contact_label" track-by="name" :options="ms_opts.send_to_contact"
                                   :option-height="200" :custom-label="contact_label" :show-labels="false" class="requiredField" :class="classes">
                        <template slot="singleLabel" slot-scope="props">
                            <span class="option__desc_single">
                              <span class="option__title">{{ props.option.name }}</span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                            <span class="option__small">{{ props.option.job_title }}</span>
                          </div>
                        </template>
                      </multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Contact Email -->
                    <ValidationProvider rules="required|email" v-slot="{errors, classes}" name="Contact Work Email" tag="div" class="col-xl-6 form-group"
                                        v-if="send_to_contact !== null">
                      <label class="form-label" for="send_to_contact_email">Contact Work Email</label>
                      <input type="text" v-model="send_contract.sent_to_email" id="send_to_contact_email" name="send_to_contact_email" class="form-input" :class="classes">
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <div v-else class="col-xl-6 form-group">
                      <label class="form-label" for="NULL_send_to_contact_email">Contact Email</label>
                      <input type="text" id="NULL_send_to_contact_email" name="NULL_send_to_contact_email" class="form-input disabled" readonly>
                    </div>
                    <div class="col-12">
                      <hr class="mt-3 mb-3">
                    </div>
                  </div>
                  <!-- Contract Type -->
                  <div class="row">
                    <div class="col-12">
                      <h4 class="mb-0 bp_color">Contract Type</h4>
                      <p class="mb-3 pt-1">Please select the type(s) of contract that you wish to send to the client.</p>
                    </div>
                  </div>
                  <ValidationProvider rules="required" v-slot="{errors, classes}" name="Contract Type">
                    <!-- Temporary Contract -->
                    <div class="row">
                      <div class="col-lg-6 form-group">
                        <div class="pretty p-icon p-smooth p-curve">
                          <input type="checkbox" value="Temporary" name="Temporary" v-model="send_contract.contract_types"/>
                          <div class="state"><i slot="extra" class="icon fa fa-check"></i><label class="bp_color">Temporary (PAYE)</label></div>
                        </div>
                      </div>
                      <div class="col-lg-6 form-group" v-if="send_contract.contract_types.includes('Temporary')">
                        <bootstrap-toggle v-model="send_contract.temporary_exclusivity" id="temporary_type" name="temporary_type"
                                          :options="{ on: 'Exclusive (Temporary)', off:'General (Temporary)' }"/>
                      </div>
                    </div>
                    <!-- Permanent Contract -->
                    <div v-if="crmType === 'recruitment'" class="row">
                      <div class="col-lg-6 form-group">
                        <div class="pretty p-icon p-smooth p-curve">
                          <input type="checkbox" value="Permanent" name="Permanent" v-model="send_contract.contract_types"/>
                          <div class="state"><i slot="extra" class="icon fa fa-check"></i><label class="bp_color">Permanent</label></div>
                        </div>
                      </div>
                      <div class="col-lg-6 form-group" v-if="send_contract.contract_types.includes('Permanent')">
                        <bootstrap-toggle v-model="send_contract.permanent_exclusivity" id="permanent_type" name="permanent_type"
                                          :options="{ on: 'Exclusive (Permanent)', off:'General (Permanent)' }"/>
                      </div>
                    </div>
                    <!-- Contractor Contract -->
                    <div class="row">
                      <div class="col-lg-6 form-group">
                        <div class="pretty p-icon p-smooth p-curve">
                          <input type="checkbox" value="Contractor" name="Contractor" v-model="send_contract.contract_types"/>
                          <div class="state"><i slot="extra" class="icon fa fa-check"></i><label class="bp_color" style="line-height: 1.5;padding-left: 56px;text-indent: 0;padding-top: 5px;">Contractor<br/>{{getPayrollSolution()}}</label></div>
                        </div>
                      </div>
                      <div class="col-lg-6" v-if="send_contract.contract_types.includes('Contractor')">
                        <div class="form-group">
                          <bootstrap-toggle v-model="send_contract.contractor_exclusivity" id="contractor_type" name="contractor_type"
                                            :options="{ on: 'Exclusive (Contractor)', off:'General (Contractor)' }"/>
                        </div>
                        <div class="form-group">
                          <bootstrap-toggle v-model="send_contract.outside_ir35" id="outside_ir35" name="outside_ir35"
                                            :options="{ on: 'Outside IR35', off:'Inside IR35' }"/>
                        </div>
                        <div class="form-group">
                          <bootstrap-toggle v-model="send_contract.comply_off_payroll" id="outside_ir35" name="outside_ir35"
                                            :options="{ on: 'Off-Payroll applies', off:'Off-Payroll does not apply' }"/>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="errors[0]">
                      <div class="col-12">
                        <div class="vvERROR">You must select at least one contract type</div>
                      </div>
                    </div>
                  </ValidationProvider>
                  <!-- Contract Information -->
                  <div class="row">
                    <div class="col-12">
                      <hr class="mt-3 mb-3">
                    </div>
                    <div class="col-12">
                      <h4 class="bp_color">Contract Information</h4>
                    </div>
                    <!-- Contract Start Date -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Contract Start Date" tag="div" class="col-xl-6 form-group">
                      <label class="form-label" for="start_date">Contract Start Date</label>
                      <datepicker v-model="send_contract.start_date" id="start_date" name="start_date" :input-class="['date-input', 'requiredField', classes]"
                                  :format="dateFormat" :clear-button="true" clear-button-icon="far fa-calendar-times" @input="select_start_date" :use-utc="true"></datepicker>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <div class="col-12">
                      <hr class="mt-3 mb-3">
                    </div>
                    <!-- Contract Length -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Contract Length (Months)" tag="div"
                                        class="col-xl-6 form-group" v-if="exclusive_term_length">
                      <label class="form-label" for="length_months">Contract Length (Months)</label>
                      <multiselect v-model="send_contract.length_months" id="length_months" class="requiredField" :class="classes" name="length_months" placeholder=""
                                   :options="ms_opts.length_months"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <div v-if="exclusive_term_length" class="col-xl-6 form-group"></div>


                    <!-- Worker Payment Cycle -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Payment Cycle" tag="div" class="col-xl-6 form-group"
                                        v-if="crmType === 'payroll'">
                      <label class="form-label" for="payment_cycle">Payment Cycle</label>
                      <multiselect v-model="send_contract.payment_cycle" id="payment_cycle" class="requiredField" :class="classes" name="payment_cycle" placeholder=""
                                   :options="ms_opts.payment_cycle" label="value"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Timesheet Submission Cycle -->
                    <ValidationProvider rules="required" v-slot="{errors, classes}" name="Payment Cycle (timesheet)" tag="div" class="col-xl-6 form-group"
                                        v-if="crmType === 'payroll'">
                      <label class="form-label" for="timesheet_cycle">Payment Cycle (timesheet)</label>
                      <multiselect v-model="send_contract.timesheet_cycle" id="timesheet_cycle" class="requiredField" :class="classes" name="timesheet_cycle" placeholder=""
                                   :options="ms_opts.timesheet_cycle" label="value"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    
                    <!-- Amendments / Notes -->
                    <ValidationProvider rules="max:2048" v-slot="{errors, classes}" name="Contract Amendments / Notes" tag="div" class="col-12 form-group">
                      <label class="form-label" for="amendments">Contract Amendments / Notes</label>
                      <textarea type="text" v-model="send_contract.amendments" id="amendments" name="amendments" class="form-input" :class="classes" rows="3"></textarea>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="col-12" v-if="crmType === 'payroll'">
                      <hr class="mt-3 mb-3">
                    </div>
                    <!-- TOTAL WEEKLY WORKER FEE -->
                    <div class="col-12 text-center" v-if="crmType === 'payroll'">
                      <h5 class="mb-0">TOTAL WEEKLY WORKER FEE AGREED (ADMIN
                        <span v-if="send_contract.pe_taken"> + PE</span>
                        <span v-if="send_contract.pa_taken"> + PA</span>)
                        <br><span class="bp_color" style="font-size: 2rem;">{{ total_fee | currency }}</span></h5>
                    </div>
                    <div class="col-12" v-if="crmType === 'payroll'">
                      <hr class="mt-3 mb-3">
                    </div>
                  </div>

                  

                    <div class="col-xl-6">
                    </div>



                  <div class="col-12" v-if="crmType === 'payroll'">
                      <hr class="mt-3 mb-3">
                    </div>
                    <!-- Minimum worker requirement -->
                  <div class="row" v-if="crmType === 'payroll'">
                    <div class="col-xl-6">
                    <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Minimum worker requirement" tag="div" class="form-group">
                      <label class="form-label" for="minimum_worker_requirement">What is the minimum worker requirement?</label>
                      <div class="input-group">
                        <input type="text" v-model="send_contract.minimum_worker_requirement" id="minimum_worker_requirement" name="minimum_worker_requirement" class="form-input requiredField" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    </div>
                  </div>
                  

                  <div class="col-12">
                      <hr class="mt-3 mb-3">
                    </div>

                  <!-- Is the client benefitting from Discounted Rates? -->
                  <div class="row">
                    <div class="col-xl-6">
                      <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="discounted_rates">Is the client benefitting from Discounted Rates?</label>
                        <div class="col-md-4 form-group">
                          <bootstrap-toggle v-model="send_contract.discounted_rates" id="discounted_rates" name="discounted_rates" :options="{ on: 'Yes', off: 'No' }" 
                                            @input="input_discounted_rates"/>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="send_contract.discounted_rates" class="row">
                    <!-- Fee Type -->
                    <ValidationProvider v-if="send_contract.discounted_rates" rules="required" v-slot="{errors, classes}" name="Fee Type" tag="div" class="col-xl-6 form-group" >
                      <label class="form-label" for="fee_type"><span v-if="crmType === 'payroll'">Admin Fee</span><span v-else>Margin</span> Type</label>
                      <multiselect v-model="send_contract.fee_type" id="fee_type" class="" :class="[classes, { 'disabled': !send_contract.discounted_rates, 'requiredField': send_contract.discounted_rates }]"  name="fee_type" placeholder=""
                                   :options="ms_opts.fee_type" label="value" :disabled="!send_contract.discounted_rates"></multiselect>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>

                    <div class="col-xl-6 form-group" v-else >
                      <label class="form-label" for="fee_type"><span v-if="crmType === 'payroll'">Admin Fee</span><span v-else>Margin</span> Type</label>
                      <input type="text" v-model="send_contract.fee_type.value" id="fee_type" name="fee_type" class="form-input" :class="[{ 'disabled': !send_contract.discounted_rates, 'requiredField': send_contract.discounted_rates }]" :readonly="!send_contract.discounted_rates">
                      
                    </div>

                    <!-- Fee Amount -->
                    <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Amount" tag="div" class="col-xl-6 form-group" >
                      <label class="form-label" for="admin_amount"><span v-if="crmType === 'payroll'">Admin Fee</span><span v-else>Margin</span> Amount</label>
                      <div class="input-group">
                        <div v-if="send_contract.fee_type !== null && send_contract.fee_type.value === '£ (Pound)'" class="input-group-prepend"><span class="input-group-text">
                            &pound;</span></div>
                        <div v-else-if="send_contract.fee_type !== null && send_contract.fee_type.value === '% (Percentage)'" class="input-group-prepend"><span
                            class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="send_contract.admin_amount" id="admin_amount" name="admin_amount" class="form-input" :class="[{ 'disabled': !send_contract.discounted_rates, 'requiredField': send_contract.discounted_rates }]" :readonly="!send_contract.discounted_rates">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>

                  
                  <div v-if="send_contract.discounted_rates" class="row">
                    
                    <!-- PE Insurance -->
                    <div class="col-xl-6" v-if="crmType === 'payroll'">
                      <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="pe_taken">Public Employers Insurance</label>
                        <div class="col-md-4 form-group">
                          <bootstrap-toggle v-model="send_contract.pe_taken" id="pe_taken" name="pe_taken" :options="{ on: 'Yes', off: 'No' }"/>
                        </div>
                      </div>
                    </div>
                    
                    <!-- <div v-if="send_contract.pe_taken && crmType === 'payroll'" class="col-xl-6 form-group text-right">
                      <p class="pt-0 mb-0">A Charge of <span class="font-weight-bold">{{ pe_ins | currency }} for P.E Insurance</span> will be made on top of
                        the<br>agreed weekly Admin Charge</p>
                    </div> -->

                    <!-- MIX PE INS -->
                    <div v-if="send_contract.pe_taken && crmType === 'payroll'" class="col-xl-6 form-group text-righ9t form-label-long-text">
                      <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Amount" tag="div">
                        <label class="form-label" for="pe_amount">A Charge of <span class="font-weight-bold">{{ send_contract.pe_amount | currency }} for P.E Insurance</span> will be made on top of
                        the agreed weekly Admin Charge</label>
                        <div class="input-group">
                          <div class="input-group-prepend"><span class="input-group-text">
                              &pound;</span></div>
                          <input type="text" v-model="send_contract.pe_amount" id="pe_amount" name="pe_amount" class="form-input disabled" :class="classes" readonly>
                        </div>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div v-else class="col-xl-6 form-group">
                      <p class="pt-0 mb-0">&nbsp;</p>
                    </div>

                    


                    <!-- PA Insurance -->
                    <div class="col-xl-6" v-if="crmType === 'payroll'">
                      <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="pa_taken">Personal Accident Insurance</label>
                        <div class="col-md-4 form-group">
                          <bootstrap-toggle v-model="send_contract.pa_taken" id="pa_taken" name="pa_taken" :options="{ on: 'Yes', off: 'No' }"/>
                        </div>
                      </div>
                    </div>
                    <!-- <div v-if="send_contract.pa_taken && crmType === 'payroll'" class="col-xl-6 form-group text-right">
                      <p class="pt-0 mb-0">A Charge of <span class="font-weight-bold">{{ pa_ins | currency }} for P.A Insurance</span> will be made on top of
                        the<br>agreed weekly Admin Charge</p>
                    </div> -->


                    
                    <!-- MIX PA INS -->
                    <div v-if="send_contract.pa_taken && crmType === 'payroll'" class="col-xl-6 form-group text-righ9t form-label-long-text">
                      <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Amount" tag="div">
                        <label class="form-label" for="pa_amount">A Charge of <span class="font-weight-bold">{{ send_contract.pa_amount | currency }} for P.A Insurance</span> will be made on top of
                        the agreed weekly Admin Charge</label>
                        <div class="input-group">
                          <div class="input-group-prepend"><span class="input-group-text">
                              &pound;</span></div>
                          <input type="text" v-model="send_contract.pa_amount" id="pa_amount" name="pa_amount" class="form-input disabled" :class="classes" readonly>
                        </div>
                        <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                    <div v-else class="col-xl-6 form-group">
                      <p class="pt-0 mb-0">&nbsp;</p>
                    </div>

                  </div>

                  <div class="col-12">
                      <hr class="mt-3 mb-3">
                  </div>
                  <!-- Payment Terms -->
                  <div class="row">
                    <div class="col-12">
                      <h4 class="bp_color">Payment Terms</h4>
                      <p class="pt-0 mb-3">Please select whether the company requires payment terms and if they do what the terms are.</p>
                    </div>
                    <!-- Require Payment Terms -->
                    <div class="col-xl-6">
                      <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="payment_terms">Will the client benefit from modified payment terms?</label>
                        <div class="col-md-4 form-group">
                          <bootstrap-toggle v-model="send_contract.payment_terms" id="payment_terms" name="payment_terms" :options="{ on: 'Yes', off: 'No' }"
                                            @input="input_payment_terms"/>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-6"></div>
                    <!-- Payment Terms Length -->
                    <ValidationProvider rules="required|decimal|max_value:255" v-slot="{errors, classes}" name="Payment Terms - Days from Invoice"
                                        tag="div" v-if="send_contract.payment_terms" class="col-xl-6 form-group">
                      <label class="form-label" for="payment_terms_length">Payment Terms - Days from Invoice</label>
                      <input type="text" v-model="send_contract.payment_terms_length" id="payment_terms_length" name="payment_terms_length" class="form-input requiredField"
                             :class="classes" required>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    <!-- Payment Terms Percentage -->
                    <ValidationProvider rules="required|decimal|max_value:255" v-slot="{errors, classes}" name="Payment Terms Percentage Fee"
                                        tag="div" v-if="send_contract.payment_terms" class="col-xl-6 form-group">
                      <label class="form-label" for="payment_terms_percentage">Payment Terms Percentage Fee</label>
                      <div class="input-group">
                        <div class="input-group-prepend"><span class="input-group-text">&percnt;</span></div>
                        <input type="text" v-model="send_contract.payment_terms_percentage" id="payment_terms_percentage" name="payment_terms_percentage"
                               class="form-input requiredField" :class="classes" required>
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                  </div>



                  <!-- Enter credit limit for modified payment terms -->
                  <div v-if="crmType === 'payroll'" >
                  <div class="row" v-if="credit_limit_for_modified_payment" >
                    <div class="col-xl-6">
                    <ValidationProvider rules="decimal|required" v-slot="{errors, classes}" name="Enter credit limit for modified payment terms" tag="div" class="form-group">
                      <label class="form-label" for="credit_limit_for_modified_payment">Enter credit limit for modified payment terms</label>
                      <div class="input-group">
                        <input type="text" v-model="send_contract.credit_limit_for_modified_payment" id="credit_limit_for_modified_payment" name="credit_limit_for_modified_payment" class="form-input requiredField" :class="classes">
                      </div>
                      <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                    </ValidationProvider>
                    </div>
                  </div>
                  </div>
                  

                  
                  <div class="col-12" v-if="crmType === 'payroll'">
                      <hr class="mt-3 mb-3">
                    </div>
                

                  <!-- Will the client be entitled to retain an amount from the workers pay? -->
                  <div class="row" v-if="crmType === 'payroll'">
                    <div class="col-xl-6">
                      <div class="row">
                        <label class="col-xl-8 cardLabel bp_color font-weight-bold" style="font-size: 0.7rem;" for="retaining_amount_from_workers_payments">Will the client be entitled to retain an amount from the workers pay?</label>
                        <div class="col-md-4 form-group">
                          <bootstrap-toggle v-model="send_contract.retaining_amount_from_workers_payments" id="retaining_amount_from_workers_payments" name="retaining_amount_from_workers_payments" :options="{ on: 'Yes', off: 'No' }" />
                        </div>
                      </div>
                    </div>
                  </div>





                  <!-- cancel/submit -->
                  <div class="row">
                    <div class="col-xl-6" v-if="notEmptyObject(this.contracts)">
                      <button @click.prevent="cancel_contract_form" class="btn orcaBtn grey_bg sm_btn w-100">Cancel</button>
                    </div>
                    <div :class="[notEmptyObject(this.contracts) ? 'col-xl-6' : 'col-12']">
                      <button type="submit" class="btn orcaBtn sm_btn w-100">
                        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving ...</span>
                        <span v-else>Save Contract & send to client contact</span>
                      </button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <!-- Orders -->
    <div class="row">
      <div class="col-12">
        <b-card header="Orders" header-tag="h4" body-class="mb-3 record_card_body">
          <!-- there is a signed contract -->
          <div v-if="check_signed_contracts && default_timesheet_auth.length > 0" class="row">
            <div class="col-12 text-right" v-if="(company.company_type === 'Active' || company.company_type === 'Live')">
              <button @click="show_create_order" class="btn orcaBtn blueBtn sm_btn mb-2" style="width: auto !important;">Create new order</button>
            </div>
            <div class="col-12">
              <datatable :type="'orders'" :rowData="orders" :loadingMessage="'Orders Loading...'" :noRowsMessage="'No Orders Found'" :columns="order_columns"
                         :heightStyle="heightStyle"></datatable>
            </div>
          </div>
          <!-- no signed contract -->
          <div v-if="!check_signed_contracts || default_timesheet_auth.length === 0 || !this.notEmptyObject(default_timesheet_auth)" class="row">
            <div class="col-12 text-center">
              <h4 class="font-weight-bold red_color mt-1">COMPANY MUST HAVE A SIGNED CONTRACT AND DEFAULT TIMESHEET AUTH SETUP TO ALLOW ORDERS TO BE RAISED</h4>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import Datepicker from 'vuejs-datepicker';
import BootstrapToggle from 'vue-bootstrap-toggle';
import PrettyCheckbox from 'pretty-checkbox-vue';
import company_contracts_datatable from "datatables/company_contracts_datatable";
import datatable from "datatables/datatable";
import Vue from "vue";

Vue.use(PrettyCheckbox);

export default {
  name: "contracts_orders",
  props: ['contracts', 'default_timesheet_auth', 'company', 'payment_process_info', 'addresses', 'contacts', 'orders'],
  components: {
    Multiselect,
    Datepicker,
    BootstrapToggle,
    company_contracts_datatable,
    'linkComponent': {
      name: 'linkComponent',
      data() {
        return {
          web_url: process.env.MIX_WEBSITE_URL
        }
      },
      methods: {
        cancel_contract() {
          this.$bus.$emit('company_contracts::cancel', this.params.data);
        }
      },
      template: '<span><a class="view_contract_link" :href="web_url + \'company/contract?link=\' + params.data.link" target="_blank">View</a>' +
        '<a v-if="!params.data.is_signed" class="view_contract_link cancel_contract_link" href="#" @click.prevent="cancel_contract">Cancel</a></span>'
    },
    datatable
  },
  data() {
    return {
      saving: false,

      pe_ins: process.env.MIX_PE_INS,
      pa_ins: process.env.MIX_PA_INS,
      show_contract_form: false,

      send_to_contact: null,
      current_contact_work_email: '',

      ms_opts: {
        contract_type: ['General', 'Exclusivity'],
        send_to_contact: [],
        length_months: ['12', '24', '36', '48', '60'],
        payment_cycle: this.$store.state.crm_options.pay_cycle,
        timesheet_cycle: this.$store.state.crm_options.timesheet_cycle,
        fee_type: this.$store.state.crm_options.fee_type,
        crm_company: ['V3 Recruitment Limited', 'V3 Contract Services Limited']
      },

      send_contract: {},

      contracts_columns: [
        {headerName: 'Contract Type', minWidth: 130, valueGetter: this.contract_types_vg, cellStyle: {"white-space": "pre-wrap"}},
        {headerName: 'Contract Start Date', minWidth: 130, valueGetter: this.start_date_vg},
        {headerName: 'Exclusivity Length (Months)', field: 'length_months', minWidth: 150},
        {headerName: 'Date Sent', minWidth: 150, valueGetter: this.date_sent_vg},
        {headerName: 'Sent To', field: 'sent_to_name', minWidth: 180},
        {headerName: 'Sent By', minWidth: 150, valueGetter: this.sent_by_vg},
        {headerName: 'Contract Signed', minWidth: 100, valueGetter: this.is_signed_vg},
        {headerName: 'Link', field: 'link', minWidth: 160, filter: false, cellRendererFramework: 'linkComponent'},
      ],

      heightStyle: 'height: 600px !important',
      order_columns: [
        {headerName: 'Order Ref', field: 'order_ref', width: 120, suppressSizeToFit: true, pinned: 'left'},
        {headerName: 'Date of Order', field: 'date_of_order', valueGetter: p => this.$options.filters.formatDate(p.data.date_of_order)},
        {headerName: 'Status', field: 'order_progress_status', minWidth: 100},
        {headerName: 'Location', field: 'job_address_full', minWidth: 160},
        {headerName: 'Position', field: 'job_title', minWidth: 160},
        {headerName: 'Main Contractor', field: 'site_main_contractor', minWidth: 120},
        {headerName: 'Quantity', field: 'workers_required', minWidth: 100},
        {headerName: 'Assigned', field: 'assigned_count', minWidth: 100},
        {headerName: 'Start Date', minWidth: 100, field: 'start_date'},
        {headerName: 'End Date', minWidth: 100, field: 'end_date'},
        {headerName: 'Consultant', minWidth: 200, field: 'consultant_name'},
        {headerName: 'Signed', minWidth: 100, field: 'order_signed'},
      ]

    }
  },
  beforeMount() {
    this.load_contract_form();
    // contacts list manipulation
    for (let i = 0; i < this.contacts.length; i++) {
      let job_title = '';
      if ((this.contacts[i].rel_profile !== null && Object.keys(this.contacts[i].rel_profile).length > 1) && this.contacts[i].rel_profile.job_title_id !== null &&
          this.contacts[i].rel_profile.job_title !== null) {
        job_title = this.contacts[i].rel_profile.job_title.job_title;
      }
      this.ms_opts.send_to_contact.push({
        id: this.contacts[i].id, name: this.contacts[i].person.first_name + ' ' + this.contacts[i].person.surname, job_title: job_title
      });
    }
    this.$bus.$on('company_contracts::cancel', this.cancel_contract);
  },
  beforeDestroy() {
    this.$bus.$off('company_contracts::cancel', this.cancel_contract);
  },
  computed: {
    exclusive_term_length() {
      return this.send_contract.temporary_exclusivity || this.send_contract.permanent_exclusivity || this.send_contract.contractor_exclusivity;
    },
    credit_limit_for_modified_payment() {
      return this.send_contract.payment_terms;
    },
    are_there_contracts() {
      return this.notEmptyObject(this.contracts);
    },
    check_for_registered_address() {
      let check = false;
      let find_reg_address = this.addresses.find(a => a.address_type === 'Registered Office')
      if (find_reg_address !== undefined) {
        this.send_contract.registered_address = find_reg_address.full;
        check = true;
      }
      return check;
    },
    check_for_pdf_fields_problem() {
      let text_problem = [];
      if (this.crmType === 'payroll') {
        if (this.company.rel_profile.office_email === null) {
          text_problem.push({ message: 'Company -> DASHBOARD & NOTES -> OFFICE CONTACT INFO -> Office Email', category: 'dashboard_notes' });
        }
        if (this.company.rel_profile.office_phone === null) {
          text_problem.push({ message: 'Company -> DASHBOARD & NOTES -> OFFICE CONTACT INFO -> Office Number', category: 'dashboard_notes' });
        }
        if (this.company.rel_payment_process_info.payroll_trading_company_id == null) {
          text_problem.push({ message: 'Company -> ACCOUNTS & PAYMENT -> COMPANY INFORMATION -> Payroll Trading Company', category: 'accounts_payment' });
        }
        if (this.company.rel_payment_process_info.payroll_solution_id == null) {
          text_problem.push({ message: 'Company -> ACCOUNTS & PAYMENT -> PAYMENT PROCESS INFORMATION -> Payroll Solution', category: 'accounts_payment' });
        }
      }
      return text_problem;
    },
    check_signed_contracts() {
      let check = false;
      if (this.notEmptyObject(this.contracts)) {
        for (let i = 0; i < this.contracts.length; i++) {
          if (this.contracts[i].is_signed) {
            check = true;
          }
        }
      }
      return check;
    },
    total_fee() {
        let pe_amount = "0";
        if(this.send_contract.pe_taken) {
            pe_amount = this.send_contract.pe_amount;
        }

        let pa_amount = "0";
        if(this.send_contract.pa_taken) {
            pa_amount = this.send_contract.pa_amount;
        }

      return parseFloat(pe_amount) + parseFloat(pa_amount) + parseFloat(this.send_contract.admin_amount);
    }
  },
  methods: {
    
    show_record_company(category) {
    if (category === 'dashboard_notes') {
      this.$store.commit('SET_COMPANY_TAB_INDEX', 0);
    } else if (category === 'accounts_payment') {
      this.$store.commit('SET_COMPANY_TAB_INDEX', 5);
    }
    this.$nextTick(() => {
      // this.$router.push('/company/record');
      this.$tabs.refresh('/company/record', true)
    });
  },

    /* Date Format for datepicker */
    dateFormat(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY");
    },

    contact_label({job_title, name}) {
      return `${job_title} - ${name}`;
    },
    // Select actions on datepicker
    select_start_date(start_date) {
      if (start_date != null) {
        this.send_contract.start_date = this.$moment(start_date).utc().format('YYYY-MM-DD');
      }
    },

    // Contracts table value getters
    contract_types_vg(params) {
      let temp = '';
      let contract_types = JSON.parse(params.data.contract_types);
      for (let i = 0; i < contract_types.length; i ++) {
        let type = '';
        if (contract_types[i] === 'Contractor') {

          type = 'Contractor'
          if (params.data.project_management_terms) {
            type = 'Project Management';
          }
          if (params.data.contractor_exclusivity) {
            type += ' (Exclusive)';
          }
        }
        else if (contract_types[i] === 'Temporary') {
          type = 'Temp'
          if (params.data.temporary_exclusivity) {
            type += ' (Exclusive)';
          }
        }
        else if (contract_types[i] === 'Permanent') {
          type = 'Perm'
          if (params.data.permanent_exclusivity) {
            type+= ' (Exclusive)';
          }
        }
        if((i + 1) !== contract_types.length){
          type += "\n"
        }
        temp += type;
      }
      return temp;
    },
    start_date_vg(params) {
      return this.$options.filters.formatDate(params.data.start_date);
    },
    date_sent_vg(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    sent_by_vg(params) {
      return params.data.sent_by.first_name + ' ' + params.data.sent_by.surname;
    },
    is_signed_vg(params) {
      return params.data.is_signed ? 'SIGNED' : 'NOT SIGNED';
    },
    // Orders table value getters
    date_of_order_vg(params) {
      return this.$options.filters.formatDate(params.data.order.date_of_order);
    },
    assigned_vg(params) {
      let assigned = 0;
      params.data.rel_assignments.forEach((assignment) => {
        if(assignment.assigned === 1) {
          assigned++;
        }
      });

      return assigned;
    },
    order_start_date_vg(params) {
      if (params.data.rel_order_position !== null){
        return this.$options.filters.formatDate(params.data.rel_order_position.start_date)
      }
    },
    order_end_date_vg(params) {
      if (params.data.rel_order_position !== null){
        return this.$options.filters.formatDate(params.data.rel_order_position.end_date)
      }
    },
    order_consultant_vg(params) {
      return params.data.order.consultant.first_name + ' ' + params.data.order.consultant.surname;
    },
    order_signed_vg(params) {
      return params.data.rel_order_progress.order_signed ? 'Signed' : 'Un-Signed';
    },
      /**
       * Return the payroll solution as a string OR null
       *
       * @returns {*|null}
       */
      getPayrollSolution(toInt = false) {
        if(toInt) {
          return this.payment_process_info.payroll_solution_id;
        }

        if (this.payment_process_info.payroll_solution_id !== null) {
            console.log({payroll_solution_id: this.payment_process_info.payroll_solution_id});
            return this.$store.state.crm_options.payroll_client_solution.find(p => p.id === this.payment_process_info.payroll_solution_id)?.value
        }

        return null;
      },
    // CONTRACTS
    load_contract_form() {
      this.send_contract = Object.assign({}, {
        company_id: this.company.id,
        link: '',
        company_name: this.company.company_name,
        ltd_reg_number: this.company.rel_profile.ltd_reg_number,
        registered_address: '',

        crm_company: '',

        contract_types: [],
          contractor_contract_type: null,
          project_management_terms: false,
        temporary_exclusivity: false,
        permanent_exclusivity: false,
        contractor_exclusivity: false,
        outside_ir35: true,
        comply_off_payroll: false,

        // contract_type: '',
        start_date: null,
        length_months: null,
        payment_cycle: null,
        timesheet_cycle: null,
        fee_type: null,
        minimum_worker_requirement: 0,
        admin_amount: process.env.MIX_PAYROLL_STANDARD_ADMIN_PE_FEE,
        // pe_taken: this.payment_process_info.payroll_pe_insurance,
        pe_taken: true,
        pe_amount: process.env.MIX_PE_INS,
        // pa_taken: this.payment_process_info.payroll_pa_insurance,
        pa_taken: true,
        pa_amount: process.env.MIX_PA_INS,
        // total_fee: 0,
        payment_terms: false,
        payment_terms_length: '',
        payment_terms_percentage: '',
        amendments: '',
        sent_by_id: this.$store.state.auth.me.id,
        sent_to_name: '',
        sent_to_email: '',
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id,

        payroll_trading_company: '',
        client_payment_day_number: 0,
        email: '',
        phone: '',
      })

      if (this.company.rel_payment_process_info.payroll_trading_company_id == 76 ){
        this.send_contract.payroll_trading_company = 'Genius Payroll Limited';
      } else if (this.company.rel_payment_process_info.payroll_trading_company_id == 77 ){
        this.send_contract.payroll_trading_company = 'Genius Contracts Limited';
      }

      // Mapping of day names to PHP-style day numbers (1-7, where 1 is Monday and 7 is Sunday)
      const dayNameToNumber = {
        'Monday': 1,
        'Tuesday': 2,
        'Wednesday': 3,
        'Thursday': 4,
        'Friday': 5,
        'Saturday': 6,
        'Sunday': 7
      };
      const dayName = this.company.rel_payment_process_info.pay_client_payment_day;
      if (dayName && dayNameToNumber.hasOwnProperty(dayName)) {
        // Get the corresponding day number in PHP-style format
        this.send_contract.client_payment_day_number = dayNameToNumber[dayName];
      } else {
        this.send_contract.client_payment_day_number = 0;
      }

      if (this.company.rel_profile.office_email != null){
        this.send_contract.email = this.company.rel_profile.office_email.email_address;
      }
      if (this.company.rel_profile.office_phone != null){
        this.send_contract.phone = this.company.rel_profile.office_phone.phone_number;
      }

      if (!this.send_contract.pe_taken) {
        this.send_contract.pe_amount = 0;
      }
      if (!this.send_contract.pa_taken) {
        this.send_contract.pa_amount = 0;
      }



      let find_reg_address = this.addresses.find(a => a.address_type === 'Registered Office')
      if (find_reg_address !== undefined) {
        this.send_contract.registered_address = find_reg_address.full;
      }
      if (this.payment_process_info.fee_margin_type !== null) {
        this.send_contract.fee_type = this.ms_opts.fee_type.find(p => p.value === this.payment_process_info.fee_margin_type);
      } else {
        this.send_contract.fee_type = this.ms_opts.fee_type.find(p => p.value === '£ (Pound)');
      }

      if (this.payment_process_info.pay_cycle_id !== null) {
        this.send_contract.payment_cycle = this.$store.state.crm_options.pay_cycle.find(p => p.id === this.payment_process_info.pay_cycle_id);
      }
      if (this.payment_process_info.timesheet_cycle_id !== null) {
        this.send_contract.timesheet_cycle = this.$store.state.crm_options.timesheet_cycle.find(p => p.id === this.payment_process_info.timesheet_cycle_id);
      }
      if (this.crmType === 'payroll') {
        this.send_contract.crm_company = 'Genius Money Limited';
        this.send_contract.contract_types = ['Contractor'];
        // if contact_+type contains 'contractor' then set contractor_contract_type to payroll solution
        if (this.send_contract.contract_types.includes('Contractor')) {
          this.send_contract.contractor_contract_type = this.getPayrollSolution();
          if(this.getPayrollSolution(true) === 75) {
            // Project Management
            this.send_contract.project_management_terms = true;
          }
        }
        // this.send_contract.payment_terms = this.payment_process_info.payroll_require_payment_terms
        if (this.payment_process_info.payroll_require_payment_terms) {
          this.send_contract.payment_terms_length = this.payment_process_info.payroll_payment_terms_length;
          this.send_contract.payment_terms_percentage = this.payment_process_info.payroll_payment_terms_perc;
        }
        this.send_contract.minimum_worker_requirement = null;
      }
      if (this.crmType === 'recruitment') {
        this.send_contract.payment_terms = this.payment_process_info.recruitment_require_payment_terms
        if (this.payment_process_info.recruitment_require_payment_terms) {
          this.send_contract.payment_terms_length = this.payment_process_info.recruitment_payment_terms_length;
          this.send_contract.payment_terms_percentage = this.payment_process_info.recruitment_payment_terms_perc;
        }
      }
    },
    show_create_contract() {
      this.load_contract_form();
      this.show_contract_form = true;
    },
    cancel_contract_form() {
      this.send_contract = {};
      this.show_contract_form = false;
    },
    input_payment_terms() {
      if (!this.send_contract.payment_terms) {
        this.send_contract.payment_terms_length = '';
        this.send_contract.payment_terms_percentage = '';
      }
      else {
        if (this.crmType === 'payroll') {
          this.send_contract.payment_terms_length = this.payment_process_info.payroll_payment_terms_length;
          this.send_contract.payment_terms_percentage = this.payment_process_info.payroll_payment_terms_perc;
        }
        if (this.crmType === 'recruitment') {
          this.send_contract.payment_terms_length = this.payment_process_info.recruitment_payment_terms_length;
          this.send_contract.payment_terms_percentage = this.payment_process_info.recruitment_payment_terms_perc;
        }
      }
    },
    input_discounted_rates() {
      if (!this.send_contract.discounted_rates) {
        this.send_contract.admin_amount = process.env.MIX_PAYROLL_STANDARD_ADMIN_PE_FEE;
        if (this.payment_process_info.fee_margin_type !== null) {
          this.send_contract.fee_type = this.ms_opts.fee_type.find(p => p.value === this.payment_process_info.fee_margin_type);
        } else {
          this.send_contract.fee_type = this.ms_opts.fee_type.find(p => p.value === '£ (Pound)');
        }
      }
    },
    send_contract_submit() {
      this.$refs.sendContractForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.sendContractForm);
        }
        else {
          this.saving = true;
          let contract_promises = [];

          // company profile
          if (this.send_contract.ltd_reg_number !== this.company.rel_profile.ltd_reg_number) {
            contract_promises.push(new Promise((resolve, reject) => {
              let sub_profile = {
                company_id: this.company.id,
                ltd_reg_number: this.send_contract.ltd_reg_number,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              }
              axios.patch(this.crmApiPath + 'company/profile/' + this.company.rel_profile.id, sub_profile).then(() => resolve()).catch(reject);
            }));
          }
          // company payment process info
          let test_pay_terms = '', test_pay_length = '', test_pay_perc = '';
          if (this.crmType === 'payroll') {
            test_pay_terms = this.payment_process_info.payroll_require_payment_terms;
            test_pay_length = this.payment_process_info.payroll_payment_terms_length;
            test_pay_perc = this.payment_process_info.payroll_payment_terms_perc;
          }
          else if (this.crmType === 'recruitment') {
            test_pay_terms = this.payment_process_info.recruitment_require_payment_terms;
            test_pay_length = this.payment_process_info.recruitment_payment_terms_length;
            test_pay_perc = this.payment_process_info.recruitment_payment_terms_perc;
          }
          let pc_id = null;
          if (this.send_contract.payment_cycle !== null && this.send_contract.payment_cycle !== undefined) {
            pc_id = this.send_contract.payment_cycle.id
          }
          let tc_id = null;
          if (this.send_contract.timesheet_cycle !== null && this.send_contract.timesheet_cycle !== undefined) {
            tc_id = this.send_contract.timesheet_cycle.id
          }
          let ppi_fee_margin_type = null;
          if (this.payment_process_info.fee_margin_type !== null) {
            ppi_fee_margin_type = this.payment_process_info.fee_margin_type.value
          }
          if (pc_id !== this.payment_process_info.pay_cycle_id ||
              tc_id !== this.payment_process_info.timesheet_cycle_id ||
              this.send_contract.fee_type !== ppi_fee_margin_type ||
              this.send_contract.admin_amount !== this.payment_process_info.fee_margin_amount ||
              this.send_contract.pe_taken !== this.payment_process_info.payroll_pe_insurance ||
              this.send_contract.pa_taken !== this.payment_process_info.payroll_pa_insurance ||
              this.send_contract.payment_terms !== test_pay_terms ||
              this.send_contract.payment_terms_length !== test_pay_length ||
              this.send_contract.payment_terms_percentage !== test_pay_perc
          ) {
              contract_promises.push(new Promise((resolve, reject) => {
                let sub_ppi = {
                  company_id: this.company.id,
                  pay_cycle_id: pc_id,
                  timesheet_cycle_id: tc_id,
                  fee_margin_type: this.send_contract.fee_type.value,
                  fee_margin_amount: this.send_contract.admin_amount,
                  payroll_pe_insurance: this.send_contract.pe_taken,
                  payroll_pa_insurance: this.send_contract.pa_taken,
                  payroll_require_payment_terms: this.send_contract.payment_terms,
                  payroll_payment_terms_length: this.send_contract.payment_terms_length,
                  payroll_payment_terms_perc: this.send_contract.payment_terms_percentage,
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
                axios.patch(this.crmApiPath + 'company/payment_process_info/' + this.payment_process_info.id, sub_ppi).then(() => resolve()).catch(reject);
              }));
          }

          // contact email
          if (this.current_contact_work_email === '') {
            contract_promises.push(new Promise((resolve, reject) => {
              axios.post(this.crmApiPath + 'contact_info/email', {
                company_id: this.company.id,
                contact_id: this.send_to_contact.id,
                contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                belongs_to_id: this.send_to_contact.id,
                email_type_id: 63, // work email
                email_address: this.send_contract.sent_to_email,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id,
              }).then(() => resolve()).catch(reject);
            }));
          }
          else if (this.current_contact_work_email.email_address !== this.send_contract.sent_to_email) {
            contract_promises.push(new Promise((resolve, reject) => {
              axios.patch(this.crmApiPath + 'contact_info/email/' + this.current_contact_work_email.id, {
                belongs_to_type: 'App\\Models\\Companies\\Contacts\\Contact',
                contact_info_model_type: 'App\\Models\\Contact_Info\\Email',
                belongs_to_id: this.send_to_contact.id,
                email_address: this.send_contract.sent_to_email,
                log_by_type: 'App\\Models\\Users\\User',
                log_by_id: this.$store.state.auth.me.id
              }).then(() => resolve()).catch(reject);
            }));
          }
          // send Contract
          let pcv = null, tcv = null;
          if (this.send_contract.payment_cycle !== null && this.send_contract.payment_cycle !== undefined) {
            pcv = this.send_contract.payment_cycle.value
          }
          if (this.send_contract.timesheet_cycle !== null && this.send_contract.timesheet_cycle !== undefined) {
            tcv = this.send_contract.timesheet_cycle.value
          }
          contract_promises.push(new Promise((resolve, reject) => {
            // Build the payload from a copy so a failed save leaves the form values intact for a retry
            let contract_payload = Object.assign({}, this.send_contract, {
              fee_type: this.send_contract.fee_type !== null ? this.send_contract.fee_type.value : null,
              total_fee: this.total_fee,
              payment_cycle: pcv,
              timesheet_cycle: tcv,
            });

            axios.post(this.crmApiPath + 'company/contract/company/send_contract', contract_payload).then(() => resolve()).catch(reject);
          }));
          Promise.all(contract_promises).then(() => {
            this.$bus.$emit('company::reload', {action: true});
            this.$bus.$emit('company_contracts::reload', {action: true});
            this.$bus.$emit('company_payment_process_info::reload', {action: true});
            this.$bus.$emit('logs::reload', {action: true});
            this.$nextTick(() => {
              this.saving = false;
              this.show_contract_form = false;
            })
          }).catch(error => this.handleContractSaveError(error));
        }
      });
    },
    /**
     * Stop the "Saving ..." spinner and surface the actual error (eg. a 422
     * validation failure) to the user, instead of leaving the button spinning
     * forever with the failure only visible in the browser console.
     */
    handleContractSaveError(error) {
      this.saving = false;
      let message = (error && error.message) || 'Please check the form and try again.';
      let data = error && error.response && error.response.data;
      if (data) {
        if (typeof data === 'string') {
          message = data;
        }
        else if (typeof data === 'object') {
          let messages = Object.values(data).reduce((all, value) => all.concat(value), []).filter(value => typeof value === 'string');
          if (messages.length > 0) {
            message = messages.join(' ');
          }
        }
      }
      this.$snotify.error(message, 'Contract Not Sent');
      console.log(error);
    },
    /**
     * Cancel (soft delete) an unsigned contract after confirmation - its e-sign link stops working
     * and a new contract can be sent. Signed contracts are rejected by the API.
     */
    cancel_contract(contract) {
      // Only act for the company record this contract belongs to (other company tabs may be open)
      if (contract.company_id !== this.company.id || contract.is_signed) {
        return;
      }
      this.$snotify.confirm('', '', {
        closeOnClick: false,
        position: 'centerCenter',
        backdrop: 0.5,
        html: '<div class="snotifyToast__title">Confirm Cancel Contract</div>' +
          '<div class="snotifyToast__body">' +
          'Are you sure that you wish to cancel the unsigned contract sent to ' + contract.sent_to_name + ' on ' +
          this.$options.filters.formatDateTime(contract.created_at) + '?<br><br>The client will no longer be able to sign it.' +
          '<div class="snotify-icon snotify-icon--confirm"><i class="fas fa-2x fa-exclamation-triangle"></i></div>' +
          '</div>',
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.$snotify.remove(toast.id);
              axios.delete(this.crmApiPath + 'company/contract/' + contract.id, {
                params: {
                  log_by_type: 'App\\Models\\Users\\User',
                  log_by_id: this.$store.state.auth.me.id
                }
              }).then(() => {
                this.$snotify.success('Contract cancelled.', 'Contract Cancelled');
                this.$bus.$emit('company_contracts::reload', {action: true});
                this.$bus.$emit('logs::reload', {action: true});
              }).catch(error => {
                let data = error && error.response && error.response.data;
                let message = (data && data.contract) ? data.contract.join(' ') : 'The contract could not be cancelled. Please try again.';
                this.$snotify.error(message, 'Contract Not Cancelled');
                console.log(error);
              });
            }
          },
          { text: 'No', action: (toast) => this.$snotify.remove(toast.id) }
        ]
      });
    },
    // ORDERS
    show_create_order() {
      this.$store.commit('SET_CREATE_ORDER_COMPANY_ID', this.company.id);
      this.$nextTick(() => {
        this.$router.push('/orders/create');
      })
    },
  },
  watch: {
    'send_contract.pe_taken'(val) {
      this.send_contract.pe_amount = !val ? 0 : this.pe_ins;
    },
    'send_contract.pa_taken'(val) {
      this.send_contract.pa_amount = !val ? 0 : this.pa_ins;
    },
    'send_to_contact'(contact) {
      if (contact !== null) {
        this.send_contract.sent_to_name = contact.name;
        axios.get(this.crmApiPath + 'contact_info/email/contact/' + contact.id + '/work_email').then(work_email => {
          if (work_email.data !== '') {
            this.current_contact_work_email = work_email.data;
            this.send_contract.sent_to_email = work_email.data.email_address;
          }
          else {
            this.current_contact_work_email = '';
            this.send_contract.sent_to_email = '';
          }
        })
      }
      else {
        this.send_contract.sent_to_name = '';
        this.send_contract.sent_to_email = '';
      }
    },
      'send_contract.contract_types'(val) {
        if (val !== undefined) {
            // if contact_+type contains 'contractor' then set contractor_contract_type to payroll solution
            if (val.includes('Contractor')) {
                this.send_contract.contractor_contract_type = this.getPayrollSolution();
                if(this.getPayrollSolution(true) === 75) {
                  this.send_contract.project_management_terms = true;
                }
            }
            else {
                this.send_contract.contractor_contract_type = null;
                this.send_contract.project_management_terms = false;
            }
        }
      }
  }
}
</script>

<style scoped lang="scss">
.sm_btn {
  display:     inline-block;
  width:       auto;
  padding:     0 15px;
  line-height: 30px;
  font-size:   0.65rem;
}
</style>
<style lang="scss">
.view_contract_link {
  color:            $white !important;
  padding:          5px 10px;
  background-color: #36a266;
  border-color:     #36a266;
  font-family:      $font-family-header;
  border-radius:    4.75px;
  text-decoration:  none !important;
  text-transform:   uppercase;
  font-size:        0.65rem;
  font-weight:      bold;

  &:hover, &:focus, &:active, &:active:focus, &.active:focus,
  &.focus, &:active.focus, &.active.focus {
    background-color: darken($green, 25%);
    border-color:     darken($green, 25%);
    cursor: pointer;
  }

  &.cancel_contract_link {
    margin-left:      5px;
    background-color: $red;
    border-color:     $red;

    &:hover, &:focus, &:active {
      background-color: darken($red, 15%);
      border-color:     darken($red, 15%);
    }
  }
}

.contracts_orders {
  .pretty {
    height: 40px;
  }

  .pretty.p-icon .state .icon {
    position:      absolute;
    /* font-size: 1.15em; */
    //width:       calc(1em + 2px);
    width:         40px;
    //height:      calc(1em + 2px);
    height:        40px;
    left:          0;
    z-index:       1;
    text-align:    center;
    line-height:   normal;
    top:           2px;
    border:        1px solid transparent;
    border-radius: 20%;
  }

  .pretty .state label {
    color:       $bc_2;
    margin-top:  0;
    line-height: 40px;
    text-indent: 4.25em;
  }

  .pretty .state label:before, .pretty .state label:after {
    top:    2px;
    height: 40px;
    width:  40px;
  }

  .pretty {
    margin-right: 0;
    color:        white;

    input {
      width: 100% !important;
    }
  }

  .pretty input:checked ~ .state .icon, .pretty input:checked ~ .state .svg, .pretty.p-toggle .state .icon, .pretty.p-toggle .state .svg {
    color:            white;
    background-color: $bc_1;
    font-size:        1.5rem;
  }

  .pretty input:checked ~ .state.p-success label:after, .pretty.p-toggle .state.p-success label:after {
    background-color: $bc_1 !important;
  }
}

#send_to_contact_container {
  .multiselect__option {
    height: auto !important;
  }

  .option__desc {
    .option__title {
      font-weight: bold;
      display:     block;
    }

    .option__small {
      font-size: 0.7rem;
      display:   block;
    }
  }
}
</style>
